import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core'
import { Color } from '../../interfaces/color.interface'
import {ColorService} from '../../services/color.service'

@Component({
  selector: 'app-color-card',
  templateUrl: './color-card.component.html',
  styleUrls: ['./color-card.component.scss']
})
export class ColorCardComponent implements OnInit, OnChanges {

  @Input() canEdit: boolean
  @Input() color: Color
  @Input() format: string
  @Output() deleted = new EventEmitter<Color>()

  constructor(private colorService: ColorService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.reformatColor()
  }

  reformatColor() {
    const p = this.colorService.parseColor(this.color.color)
    if (p) {
      this.color.color = this.colorService.toFormat(p, this.format)
    }
  }

  onDelete() {
    this.deleted.emit(this.color)
  }

  colorChanged(e) {
    this.color.color = e
    this.reformatColor()
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/color-card/color-card.component.ts